(() => {
function conditionAggregate(row,children){if(!children.some(c=>c.products.some(p=>p.sourceConditions||p.sourceConditionContexts)))return row;const tools=window.hooniesVehicleCodec?.conditionTools;if(!tools)throw Error('REQUIRED_CONDITION_CODEC_MISSING');row.products=tools.mergeProducts(children);return tools.scopeGuard(row);}
function customerLegacyYearGroups(runtime) {
  if (runtime.customerYearGroupsVersion === '20260911') return runtime;
  const selections = {...runtime.selections};
  const unique = values => [...new Set(values)].sort();
  const bounds = row => [Number.isInteger(row.yearStart) ? row.yearStart : null,
    Number.isInteger(row.yearEnd) ? row.yearEnd : null, !!row.sourceOpenEnded];
  const label = row => {
    const [start, end, open] = bounds(row);
    if (start === null) return end === null ? 'Year not specified' : `Up to ${end}`;
    if (open || end === null) return `${start} onwards`;
    return start === end ? String(start) : `${start}\u2013${end}`;
  };
  const combine = (id, identity, children, yearLabel, yearStart, yearEnd, sourceOpenEnded) => {
    const products = new Map();
    for (const child of children) for (const product of child.products) {
      const previous = products.get(product.productGid);
      if (previous && previous.handle !== product.handle) throw new Error('SBV_YEAR_PRODUCT_IDENTITY_MISMATCH');
      products.set(product.productGid, {...product,
        variantGids: unique([...(previous?.variantGids || []), ...product.variantGids])});
    }
    const rows = [...products.values()];
    return conditionAggregate({vehicle_selection_id:id, scope:'year', canonicalReleaseId:runtime.canonicalReleaseId,
      makeId:identity.makeId, makeKey:identity.makeKey, makeLabel:identity.makeLabel,
      modelId:identity.modelId, modelKey:identity.modelKey, modelLabel:identity.modelLabel,
      yearLabel, yearStart, yearEnd, sourceOpenEnded,
      memberRouteIds:unique(children.flatMap(row => row.memberRouteIds)),
      provenance:{sourceRouteIds:unique(children.flatMap(row => row.provenance.sourceRouteIds)),
        exactSelectionIds:children.map(row => row.vehicle_selection_id)},
      products:rows, productHandles:unique(rows.map(row => row.handle)), productCount:rows.length,
      resultsUrl:'/collections/all-products?vehicle_selection_id='+id},children);
  };
  const makes = runtime.makes.map(make => ({...make, models:make.models.map(model => {
    const parent = runtime.selections[model.vehicle_selection_id];
    const groups = new Map();
    for (const cohort of model.cohorts) {
      const row = runtime.selections[cohort.vehicle_selection_id];
      if (row.scope !== 'application') continue;
      const key = JSON.stringify(bounds(row));
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(row);
    }
    const years = [...groups.values()].sort((a,b) =>
      (bounds(b[0])[0] ?? -1) - (bounds(a[0])[0] ?? -1) ||
      (bounds(b[0])[1] ?? 9999) - (bounds(a[0])[1] ?? 9999) ||
      Number(bounds(b[0])[2]) - Number(bounds(a[0])[2])).map(children => {
      const first = children[0], [start,end,open] = bounds(first);
      const id = 'sbv-years-v1-'+model.vehicle_selection_id.replace(/^sbv-model-v1-/, '')+
        '-'+(start ?? 'unknown')+'-'+(open ? 'onwards' : end ?? 'unknown')+
        (open && Number.isInteger(end) && children.some(row => row.yearSearchMode) ? '-through-'+end : '');
      if (selections[id]) throw new Error('SBV_YEAR_SELECTION_COLLISION');
      const row = combine(id,parent,children,label(first),start,end,open);
      selections[id] = row;
      return {vehicle_selection_id:id, yearLabel:row.yearLabel, yearStart:start, yearEnd:end, sourceOpenEnded:open};
    });
    return {...model, cohorts:[{vehicle_selection_id:model.vehicle_selection_id,yearLabel:'All listed years'},...years]};
  })}));

  // This published legacy cohort names these applications. Membership always comes
  // from current canonical selections; no old product list or name matching is used.
  const legacyId = 'sbv-cohort-v1-ford-ford-ranger-raptor-2022-plus-81025cd58ef1';
  const canonicalIds = new Set(['ford-ranger-raptor-2022-2026',
    'ford-ranger-raptor-3-0l-petrol-2022-2026', 'ford-ranger-raptor-2-0l-diesel-2023-plus',
    'ford-ranger-raptor-next-gen-2022-plus', 'ford-ranger-raptor-us-2024-plus']);
  const legacyChildren = Object.values(runtime.selections).filter(row => row.scope === 'application' &&
    row.provenance.sourceRouteIds.some(id => canonicalIds.has(id)));
  const identity = Object.values(runtime.selections).find(row => row.scope === 'model' &&
    row.makeId === 'vehicle-make:ford' && row.modelId === 'vehicle-model-family:ford:ranger-raptor');
  if (identity && legacyChildren.length && !selections[legacyId]) {
    if (legacyChildren.some(row => row.makeId !== identity.makeId || row.yearStart < 2022))
      throw new Error('SBV_LEGACY_RAPTOR_SCOPE_MISMATCH');
    selections[legacyId] = {...combine(legacyId,identity,legacyChildren,'2022 onwards',2022,null,true),
      legacyCompatibility:true};
  }
  return {...runtime, customerYearGroupsVersion:'20260911', makes, selections,
    stats:{...runtime.stats, selectionCount:Object.keys(selections).length}};
}
function customerYearGroups(runtime, asOfYear = new Date().getUTCFullYear()) {
  const version = 'calendar-years-v1-' + asOfYear;
  if (runtime.customerYearGroupsVersion === version) return runtime;
  const grouped = customerLegacyYearGroups(runtime);
  const selections = {...grouped.selections};
  const unique = values => [...new Set(values)].sort();
  const applications = new Map();
  for (const row of Object.values(runtime.selections)) {
    if (row.scope !== 'application') continue;
    const key = row.makeId + '|' + row.modelId;
    if (!applications.has(key)) applications.set(key, []);
    applications.get(key).push(row);
  }
  // Unknown boundaries do not prove a calendar-year match. Such applications
  // remain accessible through the model and their exact incoming links.
  const known = row => row.yearSearchMode !== 'EXPLICIT_UNDATED_SELECTION_ONLY' && Number.isInteger(row.yearStart) &&
    (Number.isInteger(row.yearEnd) || row.sourceOpenEnded === true);
  const covers = (row, start, end) => known(row) && row.yearStart <= start &&
    (row.yearSearchMode ? Number.isFinite(end) && row.yearEnd >= end : row.sourceOpenEnded === true || row.yearEnd >= end);
  function combine(id, parent, children, start, end, label, openEnded = false) {
    const products = new Map();
    for (const child of children) for (const product of child.products) {
      const previous = products.get(product.productGid);
      if (previous && previous.handle !== product.handle) throw new Error('SBV_YEAR_PRODUCT_IDENTITY_MISMATCH');
      products.set(product.productGid, {...product, variantGids:unique([...(previous?.variantGids || []), ...product.variantGids])});
    }
    const rows = [...products.values()];
    return conditionAggregate({...parent, vehicle_selection_id:id, scope:'year', yearLabel:label,
      yearStart:start, yearEnd:end, sourceOpenEnded:openEnded,
      memberRouteIds:unique(children.flatMap(row => row.memberRouteIds)),
      provenance:{sourceRouteIds:unique(children.flatMap(row => row.provenance.sourceRouteIds)),
        exactSelectionIds:children.map(row => row.vehicle_selection_id)},
      products:rows, productHandles:unique(rows.map(row => row.handle)), productCount:rows.length,
      resultsUrl:'/collections/all-products?vehicle_selection_id='+id},children);
  }
  const makes = grouped.makes.map(make => ({...make, models:make.models.map(model => {
    const parent = selections[model.vehicle_selection_id];
    const children = applications.get(make.makeId+'|'+model.modelId) || [];
    const dated = children.filter(known);
    const choices = [{vehicle_selection_id:model.vehicle_selection_id, yearLabel:'All listed years'}];
    if (dated.length) {
      const first = Math.min(...dated.map(row => row.yearStart));
      const last = Math.max(...dated.map(row => row.sourceOpenEnded ? Math.max(asOfYear,row.yearStart) : Math.min(asOfYear, row.yearEnd)));
      if (first < 1800 || last > asOfYear + 10 || last-first > 200) throw new Error('SBV_CALENDAR_YEAR_BOUNDS_INVALID');
      for (let year=last; year>=first; year--) {
        const eligible = dated.filter(row => covers(row,year,year));
        if (!eligible.length) continue;
        const id='sbv-year-v1-'+model.vehicle_selection_id.replace(/^sbv-model-v1-/,'')+'-'+year;
        selections[id]=combine(id,parent,eligible,year,year,String(year));
        choices.push({vehicle_selection_id:id,yearLabel:String(year),yearStart:year,yearEnd:year,sourceOpenEnded:false});
      }
    }
    // Old range bookmarks additionally admit fitments covering the complete
    // selected range. Mere overlap must not claim an entire-range fitment.
    for (const cohort of model.cohorts) {
      const old=grouped.selections[cohort.vehicle_selection_id];
      if (old?.scope!=='year' || !known(old) || old.legacyCompatibility) continue;
      const end=old.sourceOpenEnded ? Infinity : old.yearEnd;
      const eligible=children.filter(row=>covers(row,old.yearStart,end));
      if (eligible.length) selections[old.vehicle_selection_id]=combine(old.vehicle_selection_id,parent,eligible,old.yearStart,old.yearEnd,old.yearLabel,old.sourceOpenEnded);
    }
    return {...model,cohorts:choices};
  })}));
  // Reviewed old bookmarks resolve to their exact successor without adding choices.
  for (const [oldId, targetId] of Object.entries(runtime.modelSelectionAliases || {})) {
    const target = selections[targetId];
    if (!target || selections[oldId] || !['model', 'year', 'application'].includes(target.scope)) throw new Error('SBV_MODEL_ALIAS_INVALID');
    selections[oldId] = target;
  }
  return {...grouped,makes,selections,customerYearGroupsVersion:version,
    stats:{...grouped.stats,selectionCount:Object.keys(selections).length}};
}
function customerYearMatches(text, query) {
  if (!query) return true;
  if (!/^\d{4}$/.test(query)) return text.toLowerCase().includes(query.toLowerCase());
  const year = Number(query);
  const yearText = text.split(' · ').filter(part=>/^(?:\d{4}|Up to)/.test(part))[0] || text;
  const range = yearText.match(/^(\d{4})(?:[\u2013-](\d{4})|( onwards))?(?: \(specific fitment\))?$/);
  if (range) return year >= Number(range[1]) && (range[3] || year <= Number(range[2] || range[1]));
  const until = text.match(/^Up to (\d{4})/);
  return !!until && year <= Number(until[1]);
}
function canonicalCollectionVehicle(runtime, handle) {
  if (!runtime?.canonicalReleaseId || !handle || handle === 'all-products') return null;
  const commerceBinding = window.hooniesVehicleModelProjection?.collectionFor(runtime, handle);
  if (commerceBinding) return commerceBinding;
  const applications = Object.values(runtime.selections).filter(row => row.scope === 'application'
    && row.provenance.sourceRouteIds.includes(handle));
  const identities = new Set(applications.map(row => row.makeId + '|' + row.modelId));
  if (identities.size > 1) return null;
  const matches = runtime.makes.flatMap(make => make.models.filter(model => identities.size
    ? identities.has(make.makeId + '|' + model.modelId)
    : make.makeKey + '-' + model.modelKey === handle).map(model => ({make,model})));
  if (matches.length !== 1) return null;
  const {make,model} = matches[0];
  return {handle, makeKey:make.makeKey, modelKey:model.modelKey, makeId:make.makeId, modelId:model.modelId,
    makeLabel:make.makeLabel, modelLabel:model.modelLabel, selectionId:model.vehicle_selection_id,
    basis:applications.length ? 'exact-canonical-application-route' : 'canonical-make-model-route'};
}
const customerYearLabel=row=>{if(row.scope==="model")return "All listed years";if(row.scope==="year")return row.yearLabel;const start=Number.isInteger(row.yearStart)?row.yearStart:null,end=Number.isInteger(row.yearEnd)?row.yearEnd:null;const range=start===null?(end===null?"Year not specified":"Up to "+end):(row.sourceOpenEnded||end===null?start+" onwards":start===end?String(start):start+"\u2013"+end);return range+" (specific fitment)";};
  if (window.hooniesVehicleSelectionManifest?.version === 'sbv-cohort-v1') return;

  const SELECTOR = '[data-sbv-selector]';
  const SUMMARY = '[data-sbv-selection-summary]';
  const VEHICLE_PANEL = '[data-nav2-vehicle-panel]';
  const VEHICLE_PARAM_NAMES = [
    'vehicle_selection_id',
    'vehicle_id',
    'vehicle_bucket_id',
    'vehicle_make_key',
    'vehicle_model_key',
    'vehicle_make',
    'vehicle_model',
    'vehicle_year',
  ];
  let manifestPromise = null;
  // The selector is deferred in the head, before the index in the header. Wait
  // for the full deferred-script sequence before choosing the data source.
  let initialDocumentReady = document.readyState === 'complete';
  document.addEventListener('DOMContentLoaded', () => { initialDocumentReady = true; }, { once: true });
  let routeRuntimePromise = null;
  const collectionProductsPromises = new Map();
  let comboboxSequence = 0;

  const runtimeUrl = (configuredUrl) => {
    const url = new URL(configuredUrl, window.location.origin);
    url.pathname = url.pathname.replace(/vehicle-selection-manifest\.json$/, 'vehicle-selection-runtime.json');
    return url.toString();
  };

  const decodeRuntimeManifest = (runtime) => {
    if (runtime?.schemaVersion === 'hoonies-existing-theme-models.v1') {
      if (!runtime.canonicalReleaseId || !Array.isArray(runtime.makes) || !runtime.selections
        || Object.keys(runtime.selections).length !== runtime.stats?.selectionCount) {
        throw new Error('SBV_MODEL_RUNTIME_INVALID');
      }
      runtime.makes.forEach(make => make.models.forEach(model => {
        const selected = runtime.selections[model.vehicle_selection_id];
        if (!selected || selected.scope !== 'model' || selected.modelId !== model.modelId
          || selected.makeKey !== make.makeKey || selected.canonicalReleaseId !== runtime.canonicalReleaseId
          || new Set(selected.productHandles).size !== model.productCount) {
          throw new Error('SBV_MODEL_RUNTIME_IDENTITY_OR_COUNT_MISMATCH');
        }
        model.cohorts.forEach(cohort => {
          const child = runtime.selections[cohort.vehicle_selection_id];
          if (!child || child.modelId !== model.modelId || child.makeKey !== make.makeKey
            || child.canonicalReleaseId !== runtime.canonicalReleaseId
            || child.productHandles.some(handle => !selected.productHandles.includes(handle))) {
            throw new Error('SBV_MODEL_CHILD_MISMATCH');
          }
        });
      }));
      return window.hooniesVehicleModelProjection.project(customerYearGroups(runtime));
    }
    if (runtime?.schemaVersion !== 'sbv-vehicle-selection-runtime.v1'
      || runtime?.selectionContractVersion !== 'sbv-cohort-v1'
      || runtime?.catalogYearCeiling !== 2026
      || runtime?.yearOptionContract !== 'governed_structured_cohorts_not_exploded_calendar_years'
      || JSON.stringify(runtime?.primaryContract) !== JSON.stringify(['make', 'model', 'year'])
      || !Array.isArray(runtime.selectionIds)
      || runtime.selectionIds.length !== runtime.selectionMeta?.length
      || runtime.selectionIds.length !== runtime.selectionProductIndexes?.length
      || runtime.selectionIds.length !== runtime.stats?.selectionCount) {
      throw new Error('SBV_SELECTION_RUNTIME_CONTRACT_INVALID');
    }

    const routeIdsBySelection = runtime.selectionIds.map(() => []);
    Object.entries(runtime.legacyRouteSelections || {}).forEach(([routeId, selectionIndexes]) => {
      selectionIndexes.forEach((selectionIndex) => {
        if (!routeIdsBySelection[selectionIndex]) throw new Error('SBV_SELECTION_RUNTIME_ROUTE_INDEX_INVALID');
        routeIdsBySelection[selectionIndex].push(routeId);
      });
    });
    const selections = Object.fromEntries(runtime.selectionIds.map((selectionId, selectionIndex) => {
      const meta = runtime.selectionMeta[selectionIndex];
      const productHandles = runtime.selectionProductIndexes[selectionIndex].map((productIndex) => {
        const handle = runtime.productHandles[productIndex];
        if (!handle) throw new Error('SBV_SELECTION_RUNTIME_PRODUCT_INDEX_INVALID');
        return handle;
      });
      return [selectionId, {
        vehicle_selection_id: selectionId,
        makeKey: meta[0],
        makeLabel: meta[1],
        modelKey: meta[2],
        modelLabel: meta[3],
        yearLabel: meta[4],
        yearStart: meta[5],
        yearEnd: meta[6],
        catalogYearEnd: meta[7],
        sourceOpenEnded: meta[8] === 1,
        memberRouteIds: routeIdsBySelection[selectionIndex],
        productHandles,
        resultsUrl: `/collections/all-products?vehicle_selection_id=${selectionId}`,
        provenance: {
          sourceRouteIds: routeIdsBySelection[selectionIndex],
        },
      }];
    }));
    const makes = runtime.makes.map((make) => ({
      makeKey: make[0],
      makeLabel: make[1],
      models: make[2].map((model) => ({
        modelKey: model[0],
        modelLabel: model[1],
        cohorts: model[2].map((cohort) => ({
          yearLabel: cohort[0],
          yearStart: cohort[1],
          yearEnd: cohort[2],
          catalogYearEnd: cohort[3],
          sourceOpenEnded: cohort[4] === 1,
          vehicle_selection_id: runtime.selectionIds[cohort[5]],
        })),
      })),
    }));
    return {
      schemaVersion: 'sbv-vehicle-selection-manifest.v2',
      selectionContractVersion: runtime.selectionContractVersion,
      catalogYearCeiling: runtime.catalogYearCeiling,
      primaryContract: runtime.primaryContract,
      yearOptionContract: runtime.yearOptionContract,
      source: runtime.source,
      stats: runtime.stats,
      makes,
      selections,
    };
  };

  const setDisabled = (control, disabled) => {
    if (!control) return;
    control.disabled = Boolean(disabled);
    control.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    control.hooniesCombobox?.setDisabled(Boolean(disabled));
  };

  const normaliseSearch = (value = '') => String(value).trim().toLocaleLowerCase().replace(/\s+/g, ' ');

  const enhanceSelect = (select, kind) => {
    if (!select || select.hooniesCombobox) return select?.hooniesCombobox || null;
    const originalField = select.closest('label.sbv-selector__field');
    let field = originalField;
    if (originalField) {
      field = document.createElement('div');
      [...originalField.attributes].forEach((attribute) => field.setAttribute(attribute.name, attribute.value));
      while (originalField.firstChild) field.appendChild(originalField.firstChild);
      originalField.replaceWith(field);
    }

    const label = field?.querySelector(':scope > span');
    const uid = `sbv-combobox-${++comboboxSequence}`;
    if (label) {
      label.id ||= `${uid}-label`;
      select.setAttribute('aria-labelledby', label.id);
    }
    select.classList.add('sbv-native-select--enhanced');

    const shell = document.createElement('div');
    shell.className = 'sbv-combobox';
    shell.dataset.sbvCombobox = kind;
    shell.innerHTML = `
      <button class="sbv-combobox__trigger" type="button" role="combobox" aria-haspopup="listbox" aria-expanded="false" aria-controls="${uid}-listbox">
        <span data-sbv-combobox-value></span>
        <span class="sbv-combobox__caret" aria-hidden="true"></span>
      </button>
      <div class="sbv-combobox__panel" data-sbv-combobox-panel hidden>
        <div class="sbv-combobox__search-wrap">
          <input class="sbv-combobox__search" type="search" autocomplete="off" autocapitalize="none" spellcheck="false" aria-label="Search ${kind}s" placeholder="Search ${kind}s">
        </div>
        <div class="sbv-combobox__message" data-sbv-combobox-message hidden></div>
        <div class="sbv-combobox__options" id="${uid}-listbox" role="listbox" aria-labelledby="${label?.id || ''}"></div>
      </div>`;
    select.insertAdjacentElement('afterend', shell);

    const trigger = shell.querySelector('.sbv-combobox__trigger');
    const valueNode = shell.querySelector('[data-sbv-combobox-value]');
    const panel = shell.querySelector('[data-sbv-combobox-panel]');
    const search = shell.querySelector('.sbv-combobox__search');
    const message = shell.querySelector('[data-sbv-combobox-message]');
    const listbox = shell.querySelector('.sbv-combobox__options');
    const isSidebar = Boolean(select.closest('.sbv-selector--sidebar'));
    if (isSidebar) shell.dataset.sbvComboboxMode = 'sidebar-filter';
    let disabled = select.disabled;
    let open = false;
    let activeIndex = -1;

    const optionNodes = () => [...listbox.querySelectorAll('[role="option"]:not([hidden])')];
    const fieldName = `${kind}${kind.endsWith('s') ? '' : 's'}`;
    const requiredMessage = kind === 'model'
      ? 'Choose a make before searching models.'
      : kind === 'year'
        ? 'Choose a model before searching years.'
        : '';

    const setActive = (index, focus = true) => {
      const nodes = optionNodes();
      if (!nodes.length) {
        activeIndex = -1;
        search.removeAttribute('aria-activedescendant');
        trigger.removeAttribute('aria-activedescendant');
        return;
      }
      activeIndex = Math.max(0, Math.min(index, nodes.length - 1));
      nodes.forEach((node, nodeIndex) => node.classList.toggle('is-active', nodeIndex === activeIndex));
      const active = nodes[activeIndex];
      search.setAttribute('aria-activedescendant', active.id);
      trigger.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({ block: 'nearest' });
      if (focus) search.focus({ preventScroll: true });
    };

    const render = () => {
      const query = normaliseSearch(search.value);
      const sourceOptions = [...select.options].filter((option) => option.value);
      listbox.replaceChildren();
      sourceOptions.forEach((option, index) => {
        const node = document.createElement('div');
        node.className = 'sbv-combobox__option';
        node.id = `${uid}-option-${index}`;
        node.setAttribute('role', 'option');
        node.setAttribute('aria-selected', option.selected ? 'true' : 'false');
        node.tabIndex = -1;
        node.dataset.value = option.value;
        node.textContent = option.textContent;
        node.title = option.textContent;
        node.hidden = Boolean(query && !(kind === 'year' ? customerYearMatches(option.textContent, query) : normaliseSearch(option.textContent).includes(query)));
        listbox.appendChild(node);
      });
      const matches = optionNodes();
      message.hidden = true;
      listbox.hidden = false;
      if (disabled) {
        message.textContent = requiredMessage || `No ${fieldName} are available.`;
        message.hidden = false;
        listbox.hidden = true;
      } else if (!matches.length) {
        message.textContent = `No matching ${fieldName}`;
        message.hidden = false;
        listbox.hidden = true;
      }
      activeIndex = -1;
      search.removeAttribute('aria-activedescendant');
      trigger.removeAttribute('aria-activedescendant');
    };

    const refresh = () => {
      const current = select.selectedOptions[0] || select.options[0];
      const text = current?.textContent || `Choose ${kind}`;
      valueNode.textContent = text;
      trigger.title = text;
      trigger.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      render();
    };

    const positionPanel = () => {
      if (isSidebar) {
        shell.dataset.sbvComboboxPlacement = 'inline';
        shell.dataset.sbvComboboxAlign = 'start';
        panel.style.removeProperty('left');
        panel.style.removeProperty('right');
        panel.style.removeProperty('top');
        panel.style.removeProperty('bottom');
        panel.style.removeProperty('width');
        panel.style.setProperty('--sbv-panel-max-height', `${Math.floor(Math.min(window.innerHeight * 0.42, 288))}px`);
        panel.style.setProperty('--sbv-options-max-height', `${Math.floor(Math.min(window.innerHeight * 0.32, 220))}px`);
        return;
      }
      shell.dataset.sbvComboboxPlacement = 'below';
      shell.dataset.sbvComboboxAlign = 'start';
      panel.style.removeProperty('left');
      panel.style.removeProperty('right');
      panel.style.removeProperty('top');
      panel.style.removeProperty('bottom');
      panel.style.removeProperty('width');
      panel.style.removeProperty('max-height');
      const triggerRect = trigger.getBoundingClientRect();
      const gutter = 12;
      const below = Math.max(0, window.innerHeight - triggerRect.bottom - gutter);
      const above = Math.max(0, triggerRect.top - gutter);
      const desiredListHeight = isSidebar
        ? Math.min(window.innerHeight * 0.36, 240)
        : Math.min(window.innerHeight * 0.6, 500);
      const panelChromeHeight = isSidebar ? 62 : 70;
      const desiredPanelHeight = desiredListHeight + panelChromeHeight;
      const placeAbove = below < desiredPanelHeight && above > below;
      const chosenSpace = placeAbove ? above : below;
      if (chosenSpace < 96 || triggerRect.bottom < 0 || triggerRect.top > window.innerHeight) {
        close({ returnFocus: true });
        return;
      }
      const panelHeight = Math.min(desiredPanelHeight, chosenSpace);
      const optionsHeight = Math.max(32, panelHeight - panelChromeHeight);
      const expectedWidth = isSidebar
        ? Math.min(triggerRect.width, window.innerWidth - (gutter * 2))
        : Math.min(Math.max(triggerRect.width, 280), window.innerWidth - (gutter * 2));
      if (triggerRect.left + expectedWidth > window.innerWidth - gutter) shell.dataset.sbvComboboxAlign = 'end';
      panel.style.setProperty('--sbv-panel-max-height', `${Math.floor(panelHeight)}px`);
      panel.style.setProperty('--sbv-options-max-height', `${Math.floor(optionsHeight)}px`);
      if (placeAbove) shell.dataset.sbvComboboxPlacement = 'above';
    };

    const markRootMenuState = () => {
      const root = shell.closest(SELECTOR);
      root?.classList.toggle(isSidebar ? 'sbv-selector--local-menu-open' : 'sbv-selector--menu-open', open);
    };

    const close = ({ returnFocus = false } = {}) => {
      if (!open) return;
      open = false;
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      search.value = '';
      render();
      markRootMenuState();
      if (returnFocus) trigger.focus({ preventScroll: true });
    };

    const openPanel = ({ direction = 1 } = {}) => {
      if (open) return;
      document.querySelectorAll('[data-sbv-combobox-panel]:not([hidden])').forEach((other) => {
        if (other !== panel) other.closest('.sbv-combobox')?.hooniesClose?.();
      });
      open = true;
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      markRootMenuState();
      render();
      requestAnimationFrame(() => {
        positionPanel();
        if (!open) return;
        search.focus({ preventScroll: true });
        const nodes = optionNodes();
        if (!disabled && nodes.length) {
          const selectedIndex = nodes.findIndex((node) => node.getAttribute('aria-selected') === 'true');
          const initialIndex = direction < 0
            ? nodes.length - 1
            : direction > 0
              ? 0
              : selectedIndex;
          if (initialIndex >= 0) setActive(initialIndex);
        }
      });
    };
    shell.hooniesClose = () => close();

    const choose = (node) => {
      if (!node?.dataset.value) return;
      select.value = node.dataset.value;
      refresh();
      select.dispatchEvent(new Event('change', { bubbles: true }));
      refresh();
      close({ returnFocus: true });
    };

    trigger.addEventListener('click', () => (open ? close({ returnFocus: true }) : openPanel({ direction: 0 })));
    trigger.addEventListener('keydown', (event) => {
      if (['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        openPanel({ direction: ['ArrowUp', 'End'].includes(event.key) ? -1 : 1 });
      } else if (event.key === 'Escape') {
        event.stopPropagation();
        close({ returnFocus: true });
      }
    });
    search.addEventListener('input', render);
    search.addEventListener('keydown', (event) => {
      const nodes = optionNodes();
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        close({ returnFocus: true });
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(activeIndex < 0 ? 0 : activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(activeIndex < 0 ? nodes.length - 1 : activeIndex - 1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        setActive(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        setActive(nodes.length - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        choose(nodes[activeIndex]);
      } else if (event.key === 'Tab') {
        close();
      }
    });
    listbox.addEventListener('pointerdown', (event) => event.preventDefault());
    listbox.addEventListener('click', (event) => choose(event.target.closest('[role="option"]')));
    listbox.addEventListener('mousemove', (event) => {
      const node = event.target.closest('[role="option"]');
      const index = optionNodes().indexOf(node);
      if (index >= 0) setActive(index, false);
    });
    document.addEventListener('pointerdown', (event) => {
      if (open && !shell.contains(event.target)) close();
    });
    window.addEventListener('resize', () => {
      if (open) positionPanel();
    }, { passive: true });
    window.addEventListener('scroll', () => {
      if (open) positionPanel();
    }, { passive: true, capture: true });

    const api = {
      close,
      focus: () => trigger.focus(),
      open: openPanel,
      refresh,
      setDisabled(value) {
        disabled = Boolean(value);
        search.disabled = disabled;
        refresh();
      },
    };
    select.addEventListener('change', refresh);
    select.hooniesCombobox = api;
    refresh();
    return api;
  };

  const normaliseJourneyValue = (value = '') => String(value ?? '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');

  const governedJourneyContext = () => {
    const current = new URLSearchParams(window.location.search);
    const brandCategory = current.get('brand_category') || '';
    const protectionCategory = current.get('protection_category') || '';
    const context = new URLSearchParams();
    if (brandCategory && brandCategory === protectionCategory) {
      ['brand_category', 'brand_category_title', 'protection_category', 'protection_category_title']
        .forEach((name) => {
          const value = current.get(name);
          if (value) context.set(name, value);
        });
    }

    const catalogueBrand = normaliseJourneyValue(current.get('catalogue_brand'));
    const vendor = normaliseJourneyValue(current.get('filter.p.vendor'));
    const isAlmontJourney = ['almont', 'almont4wd'].includes(catalogueBrand)
      || ['almont', 'almont4wd'].includes(vendor);
    if (isAlmontJourney) {
      ['view', 'catalogue_brand', 'filter.p.vendor'].forEach((name) => {
        const value = current.get(name);
        if (value && (name !== 'view' || value === 'almont')) context.set(name, value);
      });
    }
    return context;
  };

  const loadRouteRuntime = () => {
    if (routeRuntimePromise) return routeRuntimePromise;
    if (window.hooniesGovernedCategoryRouteSetsPromise) {
      routeRuntimePromise = window.hooniesGovernedCategoryRouteSetsPromise;
      return routeRuntimePromise;
    }
    const url = window.hooniesGovernedCategoryRouteSetsUrl;
    if (!url) return Promise.resolve(null);
    routeRuntimePromise = fetch(url, {
      credentials: 'same-origin',
      cache: 'force-cache',
      headers: { Accept: 'application/json' },
    }).then((response) => {
      if (!response.ok) throw new Error(`SBV_ROUTE_RUNTIME_HTTP_${response.status}`);
      return response.json();
    }).then((runtime) => {
      if (runtime?.schemaVersion !== 'hoonies-governed-category-route-sets.v1' || !runtime.handles) {
        throw new Error('SBV_ROUTE_RUNTIME_CONTRACT_INVALID');
      }
      return runtime;
    }).catch((error) => {
      routeRuntimePromise = null;
      window.hooniesGovernedCategoryRouteSetsPromise = null;
      throw error;
    });
    window.hooniesGovernedCategoryRouteSetsPromise = routeRuntimePromise;
    return routeRuntimePromise;
  };

  const collectionHandle = () => {
    const context = window.hooniesCategoryVehicleProjection?.context() || new URLSearchParams(window.location.search).get('collection_context') || '';
    if (/^[a-z0-9][a-z0-9-]*$/.test(context)) return context;
    const match = window.location.pathname.match(/^\/collections\/([^/]+)/);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };

  const retryDelay = (attempt, response) => {
    const retryAfter = Number(response?.headers?.get('Retry-After'));
    return Number.isFinite(retryAfter) && retryAfter > 0
      ? Math.min(retryAfter * 1000, 5000)
      : Math.min(300 * (2 ** attempt), 2400);
  };

  const fetchWithBackoff = async (url, attempt = 0) => {
    const response = await fetch(url, {
      credentials: 'same-origin',
      cache: 'force-cache',
      headers: { Accept: 'application/json' },
    });
    if (response.ok) return response;
    if ((response.status === 429 || response.status >= 500) && attempt < 3) {
      await new Promise((resolve) => window.setTimeout(resolve, retryDelay(attempt, response)));
      return fetchWithBackoff(url, attempt + 1);
    }
    throw new Error(`SBV_COLLECTION_PRODUCTS_HTTP_${response.status}`);
  };

  const loadCollectionProducts = (handle) => {
    if (!handle) return Promise.resolve([]);
    if (window.hooniesCategoryVehicleProjection) return window.hooniesCategoryVehicleProjection.products(handle);
    if (collectionProductsPromises.has(handle)) return collectionProductsPromises.get(handle);
    const promise = (async () => {
      const products = [];
      for (let page = 1; page <= 20; page += 1) {
        const url = new URL(`/collections/${encodeURIComponent(handle)}/products.json`, window.location.origin);
        url.searchParams.set('limit', '250');
        url.searchParams.set('page', String(page));
        const response = await fetchWithBackoff(url.toString());
        const batch = (await response.json())?.products || [];
        products.push(...batch);
        if (batch.length < 250) break;
      }
      return products;
    })().catch((error) => {
      collectionProductsPromises.delete(handle);
      throw error;
    });
    collectionProductsPromises.set(handle, promise);
    return promise;
  };

  const runtimeCategoryProducts = (runtime, entry, categoryKey) => {
    const categoryIndex = runtime?.categoryKeys?.indexOf(categoryKey);
    if (categoryIndex < 0) return null;
    const row = entry?.c?.find((candidate) => candidate[0] === categoryIndex);
    return Array.isArray(row?.[1]) ? row[1] : [];
  };

  const currentContextHandles = async () => {
    const handle = collectionHandle();
    if (!handle || handle === 'all-products') return null;
    const params = new URLSearchParams(window.location.search);
    const runtime = await loadRouteRuntime();
    const entry = runtime?.handles?.[handle];
    const categoryKey = normaliseJourneyValue(params.get('protection_category') || params.get('brand_category'))
      ? String(params.get('protection_category') || params.get('brand_category') || '').trim().toLowerCase()
      : '';
    const catalogueBrand = normaliseJourneyValue(params.get('catalogue_brand'));
    const vendor = normaliseJourneyValue(params.get('filter.p.vendor'));
    const isAlmontJourney = ['almont', 'almont4wd'].includes(catalogueBrand)
      || ['almont', 'almont4wd'].includes(vendor);

    if (canonicalCollectionVehicle(window.hooniesVehicleFitments?.browseModels, handle)
      || (window.hooniesCategoryVehicleProjection && ['exhausts','vehicle-seats','base-plates-mounting','skid-plates-armour'].includes(handle))) {
      const products = await loadCollectionProducts(handle);
      return new Set(products.map(product => product.handle));
    }
    if (entry && categoryKey) {
      const products = runtimeCategoryProducts(runtime, entry, categoryKey);
      if (products) return new Set(products.map((productHandle) => productHandle.toLowerCase()));
    }
    if (entry && isAlmontJourney && Array.isArray(entry.m)) {
      return new Set(entry.m.map((productHandle) => productHandle.toLowerCase()));
    }
    if (entry && !vendor && !categoryKey && Array.isArray(entry.v)) {
      return new Set(entry.v.map((productHandle) => productHandle.toLowerCase()));
    }

    const products = await loadCollectionProducts(handle);
    const filtered = products.filter((product) => {
      if (!vendor) return true;
      return normaliseJourneyValue(product.vendor) === vendor;
    });
    const handles = new Set(filtered.map((product) => String(product.handle || '').toLowerCase()).filter(Boolean));
    if (entry?.v) {
      const governedVehicleHandles = new Set(entry.v.map((productHandle) => productHandle.toLowerCase()));
      return new Set([...handles].filter((productHandle) => governedVehicleHandles.has(productHandle)));
    }
    return handles;
  };

  const manifestForContext = async (manifest) => {
    const contextHandles = await currentContextHandles();
    if (!contextHandles) return manifest;
    const selectionIds = new Set(Object.values(manifest.selections)
      .filter((selection) => selection.productHandles.some((handle) => contextHandles.has(handle.toLowerCase())))
      .map((selection) => selection.vehicle_selection_id));
    // Retain a valid incoming selection even when this category has zero products.
    // This changes the displayed selection only; product intersection remains unchanged.
    const incomingId = new URLSearchParams(window.location.search).get('vehicle_selection_id');
    const incoming = manifest.selections[incomingId];
    if (incoming) {
      selectionIds.add(incoming.vehicle_selection_id);
      const parent = manifest.makes.find(make => make.makeKey === incoming.makeKey)
        ?.models.find(model => model.modelKey === incoming.modelKey || model.modelId === incoming.modelId || model.groupMemberModelIds?.includes(incoming.modelId));
      if (parent) selectionIds.add(parent.vehicle_selection_id);
    }
    const makes = manifest.makes.map((make) => ({
      ...make,
      models: make.models.map((model) => ({
        ...model,
        cohorts: model.cohorts.filter((cohort) => selectionIds.has(cohort.vehicle_selection_id)),
      })).filter((model) => model.cohorts.length),
    })).filter((make) => make.models.length);
    return { ...manifest, makes, contextHandles, contextSelectionIds: selectionIds };
  };

  const routeHydration = async () => {
    const handle = collectionHandle();
    if (!handle) return null;
    const runtime = await loadRouteRuntime();
    const display = runtime?.handles?.[handle]?.d;
    if (!Array.isArray(display)) return null;
    return {
      makeLabel: display[0] || '',
      modelLabel: display[1] || '',
      yearLabel: display[2] || '',
      selectionId: display[3] || '',
      level: display[4] || '',
    };
  };

  const collectionContextParams = () => {
    const params = new URLSearchParams(window.location.search);
    VEHICLE_PARAM_NAMES.forEach((name) => params.delete(name));
    params.delete('page');
    return params;
  };

  const vehicleResultsUrl = (selectionId, root) => {
    const params = root?.dataset.sbvSurface === 'results' || root?.dataset.sbvSurface === 'sidebar' || root?.dataset.sbvContextCollection
      ? collectionContextParams()
      : governedJourneyContext();
    params.set('vehicle_selection_id', selectionId);
    if (root?.dataset.sbvContextCollection) params.set('collection_context', root.dataset.sbvContextCollection);
    const contextPath = root?.dataset.sbvContextPath || '/collections/all-products';
    return `${contextPath}?${params.toString()}`;
  };

  const vehicleResetUrl = (root) => {
    const params = root?.dataset.sbvSurface === 'results' || root?.dataset.sbvSurface === 'sidebar' || root?.dataset.sbvContextCollection
      ? collectionContextParams()
      : governedJourneyContext();
    if (root?.dataset.sbvContextCollection) {
      params.delete('collection_context');
      return '/collections/' + root.dataset.sbvContextCollection + (params.size ? '?' + params.toString() : '');
    }
    const contextPath = root?.dataset.sbvContextPath || '';
    if (contextPath && contextPath !== '/collections/all-products') {
      return params.size ? `${contextPath}?${params.toString()}` : contextPath;
    }
    return params.size ? `/pages/vehicle-search?${params.toString()}` : '/pages/vehicle-search';
  };

  const setOptions = (select, placeholder, entries, selected = '') => {
    select.replaceChildren();
    const first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);
    entries.forEach((entry) => {
      const option = document.createElement('option');
      option.value = entry.value;
      option.textContent = entry.label;
      select.appendChild(option);
    });
    if (selected && entries.some((entry) => entry.value === selected)) select.value = selected;
    select.hooniesCombobox?.refresh();
  };

async function loadCanonicalModelData() {
  await window.hooniesKooksIndexReady;
  const ready = () => window.hooniesVehicleFitments?.browseModels;
  if (ready()) return Promise.resolve(ready());
  const configured = window.hooniesVehicleFitmentIndexUrl;
  if (!configured) return Promise.reject(new Error('SBV_CANONICAL_INDEX_URL_MISSING'));
  const url = new URL(configured, document.baseURI).href;
  return new Promise((resolve, reject) => {
    const existing = [...document.scripts].find(script => script.src === url);
    const script = existing || document.createElement('script');
    let settled = false;
    const finish = (error) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      script.removeEventListener('load', loaded);
      script.removeEventListener('error', failed);
      if (error) reject(error);
      else if (ready()) resolve(ready());
      else reject(new Error('SBV_CANONICAL_MODEL_DATA_MISSING'));
    };
    const loaded = () => finish();
    const failed = () => finish(new Error('SBV_CANONICAL_INDEX_LOAD_FAILED'));
    const timer = setTimeout(() => finish(new Error('SBV_CANONICAL_INDEX_TIMEOUT')), 15000);
    script.addEventListener('load', loaded, {once:true});
    script.addEventListener('error', failed, {once:true});
    if (!existing) {
      script.src = url;
      script.dataset.sbvCanonicalIndex = 'true';
      document.head.appendChild(script);
    }
  });
}

  const load = (options = {}) => {
    if (window.hooniesVehicleData) return window.hooniesVehicleData.load(options);
    if (!initialDocumentReady) return new Promise(resolve => {
      document.addEventListener('DOMContentLoaded', () => resolve(load()), { once: true });
    });
    if (manifestPromise) return manifestPromise;
    // Every entry point waits for the same canonical index. Never populate an
    // independent legacy model list when that index is absent or still loading.
    manifestPromise = loadCanonicalModelData().then(modelData => {
      if (modelData.schemaVersion !== 'hoonies-existing-theme-models.v1') {
        throw new Error('SBV_MODEL_RUNTIME_SCHEMA_INVALID');
      }
      const manifest = decodeRuntimeManifest(modelData);
      window.dispatchEvent(new CustomEvent('hoonies:vehicle-selection-manifest-ready', { detail: manifest }));
      return manifest;
    }).catch(error => { manifestPromise = null; throw error; });
    return manifestPromise;
  };

  const selectorFormMarkup = () => `
    <form class="sbv-selector__form" data-sbv-form>
      <label class="sbv-selector__field"><span>Make</span><select data-sbv-make aria-label="Make"><option value="">Choose make</option></select></label>
      <label class="sbv-selector__field"><span>Model</span><select data-sbv-model aria-label="Model" disabled aria-disabled="true"><option value="">Choose model</option></select></label>
      <label class="sbv-selector__field"><span>Year</span><select data-sbv-year aria-label="Year" disabled aria-disabled="true"><option value="">Choose year</option></select></label>
      <button class="btn btn--amber sbv-selector__submit" type="submit" data-sbv-submit disabled>View parts</button>
    </form>
    <div class="sbv-selector__footer">
      <p class="sbv-selector__status" data-sbv-status aria-live="polite">Loading vehicle data&hellip;</p>
      <button class="sbv-selector__change" type="button" data-sbv-change hidden>Change vehicle</button>
      <button class="sbv-selector__reset" type="button" data-sbv-reset disabled>Reset</button>
    </div>`;

  const sidebarFilterMarkup = () => `
    <form class="sbv-selector__form sbv-selector__form--local-filter" data-sbv-form data-sbv-local-filter>
      <label class="sbv-selector__field"><span>Make</span><select data-sbv-make aria-label="Filter by make"><option value="">Choose make</option></select></label>
      <label class="sbv-selector__field"><span>Model</span><select data-sbv-model aria-label="Filter by model" disabled aria-disabled="true"><option value="">Choose model</option></select></label>
      <label class="sbv-selector__field"><span>Year</span><select data-sbv-year aria-label="Filter by year" disabled aria-disabled="true"><option value="">Choose year</option></select></label>
    </form>
    <div class="sbv-selector__footer sbv-selector__footer--local-filter">
      <p class="sbv-selector__status" data-sbv-status aria-live="polite">Loading vehicle filters&hellip;</p>
      <button class="sbv-selector__reset" type="button" data-sbv-reset disabled>Reset</button>
    </div>`;

  const mountInlineSelector = (shell, surface) => {
      if (!shell || shell.dataset.sbvInlineMounted === 'true') return;
      const isSidebar = surface === 'sidebar';
      const isHeader = surface === 'header';
      shell.dataset.sbvInlineMounted = 'true';
      shell.dataset.sbvSidebarMounted = isSidebar ? 'true' : 'false';
      shell.dataset.sbvSurface = surface;
      shell.setAttribute('data-sbv-selector', '');
      if (isSidebar) shell.setAttribute('data-sbv-requires-vehicle-param', '');
      shell.removeAttribute('data-nav2-vehicle-panel');
      shell.removeAttribute('data-fitment-tuples');
      shell.removeAttribute('data-coarse-fitment-tuples');
      shell.classList.remove('fit-picker');
      shell.classList.add('sbv-selector', `sbv-selector--${surface}`);
      shell.replaceChildren();
      shell.insertAdjacentHTML('afterbegin', isHeader
        ? `<div class="main-nav__panel-grid"><div class="main-nav__panel-col sbv-selector--header__inner"><a class="main-nav__panel-heading" href="/pages/vehicle-search">Search by Vehicle</a>${selectorFormMarkup()}</div></div>`
        : isSidebar ? sidebarFilterMarkup() : selectorFormMarkup());
      if (isSidebar) {
        const legacySummary = shell.closest('.collection-catalogue-filters__vehicle')
          ?.querySelector('[data-all-products-filter-vehicle]');
        if (legacySummary) {
          legacySummary.hidden = true;
          legacySummary.style.setProperty('display', 'none');
        }
      }
  };

  const suppressDuplicatePanel = (shell) => {
    if (!shell) return;
    shell.hidden = true;
    shell.setAttribute('inert', '');
    shell.dataset.sbvSuppressedDuplicate = 'true';
    shell.querySelectorAll('button, input, select, textarea, a[href]').forEach((control) => control.setAttribute('tabindex', '-1'));
  };

  const activeBodySelectors = () => [...document.querySelectorAll(SELECTOR)]
    .filter((root) => root.dataset.sbvSurface !== 'header' && root.dataset.sbvSuppressedDuplicate !== 'true');

  const mountInlineSelectors = (node = document) => {
    const shells = [];
    if (node.matches?.(VEHICLE_PANEL)) shells.push(node);
    node.querySelectorAll?.(VEHICLE_PANEL).forEach((shell) => shells.push(shell));
    const headerShells = shells.filter((shell) => Boolean(shell.closest('.main-nav, .site-header')));
    const bodyShells = shells.filter((shell) => !headerShells.includes(shell));

    bodyShells
      .sort((left, right) => Number(right.dataset.nav2InlineFilter === 'true') - Number(left.dataset.nav2InlineFilter === 'true'))
      .forEach((shell, index) => {
        const isSidebar = shell.dataset.nav2InlineFilter === 'true';
        const isHome = Boolean(shell.closest('[data-sbv-preferred-surface="home"], .home-hero__finder'));
        if (isSidebar && activeBodySelectors().some((root) => root.dataset.sbvSurface === 'sidebar' && root !== shell)) {
          suppressDuplicatePanel(shell);
          return;
        }
        if (activeBodySelectors().length && !isSidebar && !isHome) {
          suppressDuplicatePanel(shell);
          return;
        }
        if (index > 0 && !isSidebar && !isHome) {
          suppressDuplicatePanel(shell);
          return;
        }
        mountInlineSelector(shell, isSidebar ? 'sidebar' : isHome ? 'home' : 'inline');
      });

    const existingBody = activeBodySelectors();
    const allHeaderShells = [...document.querySelectorAll('.main-nav [data-nav2-vehicle-panel], .site-header [data-nav2-vehicle-panel], .main-nav [data-sbv-surface="header"], .site-header [data-sbv-surface="header"]')];
    if (existingBody.length) {
      allHeaderShells.forEach(suppressDuplicatePanel);
      return;
    }
    allHeaderShells.forEach((shell, index) => {
      if (index === 0) mountInlineSelector(shell, 'header');
      else suppressDuplicatePanel(shell);
    });
  };

  const init = async (root) => {
    if (!root || root.dataset.sbvSuppressedDuplicate === 'true' || root.dataset.sbvReady === 'true' || root.dataset.sbvLoading === 'true') return;
    root.dataset.sbvLoading = 'true';
    let initialRouteHydration = null;
    if (root.hasAttribute('data-sbv-requires-vehicle-param')) {
      const params = new URLSearchParams(window.location.search);
      if (!params.has('vehicle_selection_id') && !params.has('vehicle_id') && !params.has('vehicle_bucket_id')) {
        try {
          const hydration = await routeHydration();
          initialRouteHydration = hydration;
          if (hydration?.selectionId) root.dataset.sbvInitialSelection = hydration.selectionId;
        } catch (error) {
          root.dataset.sbvError = 'route-hydration';
          console.warn(error);
        }
      }
    }

    const makeSelect = root.querySelector('[data-sbv-make]');
    const modelSelect = root.querySelector('[data-sbv-model]');
    const yearSelect = root.querySelector('[data-sbv-year]');
    const form = root.querySelector('[data-sbv-form]');
    const submit = root.querySelector('[data-sbv-submit]');
    const reset = root.querySelector('[data-sbv-reset]');
    const status = root.querySelector('[data-sbv-status]');
    const isSidebar = root.dataset.sbvSurface === 'sidebar';
    if (!makeSelect || !modelSelect || !yearSelect || !form || (!submit && !isSidebar)) {
      root.dataset.sbvError = 'markup';
      delete root.dataset.sbvLoading;
      return;
    }

    enhanceSelect(makeSelect, 'make');
    enhanceSelect(modelSelect, 'model');
    enhanceSelect(yearSelect, 'year');

    setDisabled(makeSelect, true);
    setDisabled(modelSelect, true);
    setDisabled(yearSelect, true);
    setDisabled(submit, true);
    if (reset) setDisabled(reset, true);
    if (status) status.textContent = 'Loading vehicle data…';

    try {
      const baseManifest = await load();
      const categoryProjection = window.hooniesCategoryVehicleProjection;
      const initialParams = new URLSearchParams(window.location.search);
      if (categoryProjection && initialParams.get('vehicle_model_key') && !initialParams.get('vehicle_selection_id') && ['exhausts','vehicle-seats','base-plates-mounting','skid-plates-armour'].includes(collectionHandle())) {
        const currentRuntime = await categoryProjection.runtimeFor(collectionHandle());
        const make = currentRuntime.tree.find(row => row.k === initialParams.get('vehicle_make_key'));
        const model = make?.m.find(row => row.k === initialParams.get('vehicle_model_key') || row.aliases?.includes(initialParams.get('vehicle_model_key')));
        if (model) root.dataset.sbvInitialSelection = model.selectionId;
      }
      const collectionContext = collectionHandle();
      const isInlineCollection = root.dataset.sbvSurface === 'inline' && collectionContext && collectionContext !== 'all-products';
      const hasExplicitContext = Boolean(window.hooniesCategoryVehicleProjection?.context()) || new URLSearchParams(window.location.search).has('collection_context');
      const legacyVehicleCollection = !hasExplicitContext && (isInlineCollection || isSidebar || root.dataset.sbvSurface === 'results')
        ? canonicalCollectionVehicle(baseManifest, collectionContext) : null;
      const isContextualSurface = !legacyVehicleCollection && (isInlineCollection || hasExplicitContext || root.dataset.sbvSurface === 'results' || root.dataset.sbvSurface === 'sidebar');
      if (!legacyVehicleCollection && (isInlineCollection || hasExplicitContext)) root.dataset.sbvContextCollection = collectionContext;
      const scopedCategory = ['exhausts','vehicle-seats','base-plates-mounting','skid-plates-armour'].includes(collectionContext);
      const manifest = isContextualSurface && collectionContext && collectionContext !== 'all-products'
        ? await manifestForContext(scopedCategory
          ? await window.hooniesVehicleData.categoryManifest(collectionContext, {products: await loadCollectionProducts(collectionContext), selectionId: initialParams.get('vehicle_selection_id') || root.dataset.sbvInitialSelection, makeKey: initialParams.get('vehicle_make_key')})
          : await load({ full: true })) : baseManifest;
      if (root.dataset.sbvSurface === 'sidebar') {
        root.dataset.sbvContextPath = window.location.pathname;
      } else if (root.dataset.sbvSurface === 'results') {
        const handle = collectionHandle();
        const routeRuntime = await loadRouteRuntime();
        root.dataset.sbvContextPath = handle && !routeRuntime?.handles?.[handle]
          ? window.location.pathname
          : '/collections/all-products';
      }
      if (root.dataset.sbvContextCollection) {
        const family = window.location.pathname.match(/\/type-[^/]+$/)?.[0] || '';
        root.dataset.sbvContextPath = '/collections/all-products' + family;
      }
      if (legacyVehicleCollection) {
        root.dataset.sbvVehicleCollection = collectionContext;
        root.dataset.sbvContextPath = '/collections/all-products' + (window.location.pathname.match(/\/type-[^/]+$/)?.[0] || '');
        root.dataset.sbvContextCollection = collectionContext;
        delete root.dataset.sbvInitialSelection;
        if (legacyVehicleCollection.basis === 'canonical-commerce-model-collection-binding') {
          const destination = new URL(window.location.href);
          destination.pathname = root.dataset.sbvContextPath;
          destination.searchParams.delete('collection_context');
          destination.searchParams.delete('page');
          if (!VEHICLE_PARAM_NAMES.some(name=>initialParams.has(name))) {
            destination.searchParams.set('vehicle_selection_id',legacyVehicleCollection.selectionId);
          }
          window.location.replace(destination.pathname + destination.search + destination.hash);
          return;
        }
        if (initialParams.has('vehicle_selection_id') || initialParams.has('vehicle_id') || initialParams.has('vehicle_bucket_id')) {
          const destination = new URL(window.location.href);
          destination.pathname = root.dataset.sbvContextPath;
          destination.searchParams.set('collection_context', collectionContext);
          destination.searchParams.delete('page');
          window.location.replace(destination.pathname + destination.search + destination.hash);
          return;
        }
      }
      const makesByKey = new Map(manifest.makes.map((make) => [make.makeKey, make]));
      let chosenSelection = null;
      let applyingSynchronizedDraft = false;

      const clearSelection = (message = 'Choose a make, model and year.') => {
        chosenSelection = null;
        root.dataset.vehicleSelectionId = '';
        root.dataset.sbvYearLabel = '';
        setDisabled(submit, true);
        if (status) status.textContent = message;
      };

      const resetYears = (message = 'Choose a model to see available years.') => {
        setOptions(yearSelect, 'Choose year', []);
        setDisabled(yearSelect, true);
        clearSelection(message);
      };

      const resetModels = (message = 'Choose a make to see available models.') => {
        setOptions(modelSelect, 'Choose model', []);
        setDisabled(modelSelect, true);
        resetYears(message);
      };

      const populateModels = (makeKey, selectedModel = '') => {
        const make = makesByKey.get(makeKey);
        const entries = (make?.models || []).map((model) => ({ value: model.modelKey, label: model.modelLabel }));
        setOptions(modelSelect, 'Choose model', entries, selectedModel);
        setDisabled(modelSelect, entries.length === 0);
        resetYears(entries.length ? 'Choose a model to see available years.' : 'No structured model years are available for this make.');
      };

      const populateYearCohorts = (makeKey, modelKey, selectedSelectionId = '') => {
        const model = makesByKey.get(makeKey)?.models.find((candidate) => candidate.modelKey === modelKey);
        const yearLabelNode = yearSelect.closest('.sbv-selector__field')?.querySelector('span');
        if (yearLabelNode) yearLabelNode.textContent = (model?.displayVersionCount ?? model?.versions?.length ?? 0) > 1 ? 'Version / year' : 'Year';
        yearSelect.setAttribute('aria-label', (model?.displayVersionCount ?? model?.versions?.length ?? 0) > 1 ? 'Filter by version or year' : 'Filter by year');
        const entries = (model?.cohorts || []).map((cohort) => ({
          value: cohort.vehicle_selection_id,
          label: cohort.yearLabel,
        }));
        const incoming = manifest.selections[selectedSelectionId];
        if (incoming && incoming.makeKey === makeKey && (incoming.modelKey === modelKey || model?.groupMemberModelIds?.includes(incoming.modelId)) && !entries.some(entry => entry.value === selectedSelectionId)) {
          entries.push({ value: selectedSelectionId, label: customerYearLabel(incoming) });
        }
        setOptions(yearSelect, 'Choose year', entries, selectedSelectionId || model?.vehicle_selection_id || '');
        setDisabled(yearSelect, entries.length === 0);
        clearSelection(entries.length ? 'Choose the year range.' : 'No governed year ranges are available for this model.');
      };

      const resolve = () => {
        const make = makesByKey.get(makeSelect.value);
        const model = make?.models.find((candidate) => candidate.modelKey === modelSelect.value);
        const candidate = manifest.selections[yearSelect.value];
        chosenSelection = model && candidate && candidate.makeKey === makeSelect.value
          && (candidate.modelKey === modelSelect.value || model.groupMemberModelIds?.includes(candidate.modelId)) ? candidate : null;
        if (!chosenSelection) {
          clearSelection(yearSelect.value ? 'This selection has no governed result. Choose again.' : 'Choose the year range.');
          return;
        }
        root.dataset.vehicleSelectionId = chosenSelection.vehicle_selection_id;
        root.dataset.sbvYearLabel = customerYearLabel(chosenSelection);
        setDisabled(submit, false);
        if (reset) setDisabled(reset, false);
        if (status) status.textContent = `${chosenSelection.makeLabel} ${chosenSelection.modelLabel} ${customerYearLabel(chosenSelection)}`;
        root.dispatchEvent(new CustomEvent('hoonies:vehicle-selection-ready', {
          bubbles: true,
          detail: chosenSelection,
        }));
      };

      const emitDraft = () => {
        if (applyingSynchronizedDraft) return;
        window.dispatchEvent(new CustomEvent('hoonies:vehicle-selection-draft', {
          detail: {
            source: root,
            makeKey: makeSelect.value,
            modelKey: modelSelect.value,
            selectionId: yearSelect.value,
          },
        }));
      };

      const applySidebarFilter = () => {
        if (!isSidebar) return;
        if (legacyVehicleCollection && chosenSelection) {
          window.location.assign(vehicleResultsUrl(chosenSelection.vehicle_selection_id, root));
          return;
        }
        root.dispatchEvent(new CustomEvent('hoonies:vehicle-filter-change', {
          bubbles: true,
          detail: chosenSelection ? {
            vehicle_selection_id: chosenSelection.vehicle_selection_id,
            vehicle_make: chosenSelection.makeLabel,
            vehicle_model: chosenSelection.modelLabel,
            vehicle_year: chosenSelection.yearLabel,
          } : {
            vehicle_selection_id: '',
            vehicle_make: '',
            vehicle_model: '',
            vehicle_year: '',
          },
        }));
      };

      setOptions(makeSelect, 'Choose make', manifest.makes.map((make) => ({
        value: make.makeKey,
        label: make.makeLabel,
      })));
      if (!manifest.makes.length) {
        form.hidden = true;
        if (status) status.textContent = 'No vehicle-specific choices are available for this collection.';
        root.hidden = false;
        root.dataset.sbvReady = 'true';
        root.dataset.sbvEmpty = 'true';
        delete root.dataset.sbvError;
        return;
      }
      form.hidden = false;
      setDisabled(makeSelect, false);

      let makeRequest = 0;
      makeSelect.addEventListener('change', async () => {
        const request = ++makeRequest;
        if (!makeSelect.value) {
          resetModels();
          if (reset) setDisabled(reset, true);
          emitDraft();
          return;
        }
        const makeKey = makeSelect.value;
        if (window.hooniesVehicleData) {
          resetModels('Loading models...');
          try {
            await load({ makeKey });
            if (scopedCategory && isContextualSurface) {
              const contextual = await manifestForContext(await window.hooniesVehicleData.categoryManifest(collectionContext, {products: await loadCollectionProducts(collectionContext), makeKey}));
              if (request !== makeRequest || makeSelect.value !== makeKey) return;
              Object.assign(manifest.selections, contextual.selections);
              const currentMake = contextual.makes.find(make => make.makeKey === makeKey);
              if (currentMake) makesByKey.set(makeKey, currentMake); else makesByKey.delete(makeKey);
            }
          } catch (error) {
            if (request === makeRequest && status) status.textContent = 'Models could not be loaded. Choose the make again to retry.';
            return;
          }
          if (request !== makeRequest || makeSelect.value !== makeKey) return;
        }
        populateModels(makeKey);
        if (reset) setDisabled(reset, !makeSelect.value);
        emitDraft();
      });
      modelSelect.addEventListener('change', () => {
        populateYearCohorts(makeSelect.value, modelSelect.value);
        resolve();
        emitDraft();
        applySidebarFilter();
      });
      yearSelect.addEventListener('change', () => {
        resolve();
        emitDraft();
        applySidebarFilter();
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        resolve();
        if (!chosenSelection) return;
        if (isSidebar) {
          applySidebarFilter();
          return;
        }
        window.location.assign(vehicleResultsUrl(chosenSelection.vehicle_selection_id, root));
      });
      reset?.addEventListener('click', () => {
        if (isSidebar) {
          makeSelect.value = '';
          makeSelect.hooniesCombobox?.refresh();
          resetModels();
          setDisabled(reset, true);
          makeSelect.hooniesCombobox?.focus();
          emitDraft();
          applySidebarFilter();
          return;
        }
        if (root.hasAttribute('data-sbv-requires-vehicle-param')) {
          window.location.assign(vehicleResetUrl(root));
          return;
        }
        makeSelect.value = '';
        makeSelect.hooniesCombobox?.refresh();
        resetModels();
        setDisabled(reset, true);
        makeSelect.hooniesCombobox?.focus();
        emitDraft();
      });

      const change = root.querySelector('[data-sbv-change]');
      if (change) {
        change.hidden = !(root.dataset.sbvSurface === 'sidebar');
        change.addEventListener('click', () => {
          makeSelect.hooniesCombobox?.open({ direction: 0 });
        });
      }

      const applySelectionId = (selectionId = '') => {
        const initial = manifest.selections[selectionId];
        if (!initial) {
          makeSelect.value = '';
          makeSelect.hooniesCombobox?.refresh();
          resetModels();
          if (reset) setDisabled(reset, true);
          return;
        }
        makeSelect.value = initial.makeKey;
        makeSelect.hooniesCombobox?.refresh();
        const visibleModel = makesByKey.get(initial.makeKey)?.models.find(model=>model.modelId===initial.modelId || model.groupMemberModelIds?.includes(initial.modelId));
        const visibleKey = visibleModel?.modelKey || initial.modelKey;
        populateModels(initial.makeKey, visibleKey);
        modelSelect.value = visibleKey;
        modelSelect.hooniesCombobox?.refresh();
        populateYearCohorts(initial.makeKey, visibleKey, initial.vehicle_selection_id);
        yearSelect.value = initial.vehicle_selection_id;
        yearSelect.hooniesCombobox?.refresh();
        resolve();
      };

      root.hooniesApplyVehicleDraft = (detail = {}) => {
        if (detail.source === root) return;
        applyingSynchronizedDraft = true;
        try {
          if (!detail.makeKey || !makesByKey.has(detail.makeKey)) {
            applySelectionId('');
            return;
          }
          makeSelect.value = detail.makeKey;
          makeSelect.hooniesCombobox?.refresh();
          populateModels(detail.makeKey, detail.modelKey || '');
          if (!detail.modelKey) return;
          modelSelect.value = detail.modelKey;
          modelSelect.hooniesCombobox?.refresh();
          populateYearCohorts(detail.makeKey, detail.modelKey, detail.selectionId || '');
          if (!detail.selectionId) return;
          yearSelect.value = detail.selectionId;
          yearSelect.hooniesCombobox?.refresh();
          resolve();
        } finally {
          applyingSynchronizedDraft = false;
        }
      };

      root.hooniesApplyVehicleSelectionFromLocation = () => {
        const selectionId = new URLSearchParams(window.location.search).get('vehicle_selection_id')
          || root.dataset.sbvInitialSelection || '';
        if (selectionId) { applySelectionId(selectionId); return; }
        if (legacyVehicleCollection) {
          makeSelect.value = legacyVehicleCollection.makeKey;
          makeSelect.hooniesCombobox?.refresh();
          populateModels(makeSelect.value, legacyVehicleCollection.modelKey);
          modelSelect.hooniesCombobox?.refresh();
          populateYearCohorts(makeSelect.value, modelSelect.value);
          yearSelect.value = '';
          yearSelect.hooniesCombobox?.refresh();
          clearSelection('Choose your year to find matching products.');
          if (reset) setDisabled(reset, false);
          return;
        }
        if (root.dataset.sbvRouteHydration) {
          try { applyRouteDisplay(JSON.parse(root.dataset.sbvRouteHydration)); return; } catch {}
        }
        applySelectionId('');
      };
      const applyRouteDisplay = (hydration) => {
        if (legacyVehicleCollection || !hydration?.makeLabel || !hydration?.modelLabel || !hydration?.yearLabel) return;
        if (new URLSearchParams(window.location.search).get('vehicle_selection_id') || root.dataset.sbvInitialSelection) return;
        const make = manifest.makes.find((candidate) => candidate.makeLabel === hydration.makeLabel);
        const model = make?.models.find((candidate) => candidate.modelLabel === hydration.modelLabel);
        if (!make || !model) return;
        makeSelect.value = make.makeKey;
        makeSelect.hooniesCombobox?.refresh();
        populateModels(make.makeKey, model.modelKey);
        modelSelect.value = model.modelKey;
        modelSelect.hooniesCombobox?.refresh();
        populateYearCohorts(make.makeKey, model.modelKey);
        const routeOption = document.createElement('option');
        routeOption.value = '__governed_route_display__';
        routeOption.textContent = hydration.yearLabel;
        yearSelect.appendChild(routeOption);
        yearSelect.value = routeOption.value;
        yearSelect.hooniesCombobox?.refresh();
        root.dataset.sbvYearLabel = hydration.yearLabel;
        setDisabled(yearSelect, false);
        setDisabled(submit, true);
        if (reset) setDisabled(reset, false);
        if (status) status.textContent = `${hydration.makeLabel} ${hydration.modelLabel} ${hydration.yearLabel}`;
      };
      root.hooniesApplyVehicleRouteHydration = applyRouteDisplay;
      root.hooniesApplyVehicleSelectionFromLocation();
      if (initialRouteHydration) applyRouteDisplay(initialRouteHydration);
      if (root.dataset.sbvRouteHydration) { try { applyRouteDisplay(JSON.parse(root.dataset.sbvRouteHydration)); } catch {} }

      root.hidden = false;
      root.dataset.sbvReady = 'true';
      delete root.dataset.sbvError;
    } catch (error) {
      root.dataset.sbvError = 'manifest';
      form.hidden = false;
      root.hidden = false;
      if (status) status.textContent = 'Vehicle search is unavailable right now. Please try again.';
      if (!root.querySelector('[data-sbv-retry]')) {
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'sbv-selector__reset';
        retry.dataset.sbvRetry = 'true';
        retry.textContent = 'Retry vehicle search';
        retry.addEventListener('click', () => { retry.remove(); init(root); });
        (status || root).append(' ', retry);
      }
      console.warn(error);
    } finally {
      delete root.dataset.sbvLoading;
    }
  };

  const initSummary = async (root) => {
    if (!root || root.dataset.sbvSummaryReady === 'true' || root.dataset.sbvSummaryLoading === 'true') return;
    if (window.hooniesVehicleData && !VEHICLE_PARAM_NAMES.some(name => new URLSearchParams(window.location.search).has(name))) {
      root.hidden = true;
      return;
    }
    root.dataset.sbvSummaryLoading = 'true';
    const legacySummary = root.closest('[data-all-products-secondary-filters]')
      ?.querySelector('[data-all-products-filter-vehicle]');
    try {
      const manifest = await load();
      const hydration = canonicalCollectionVehicle(manifest, collectionHandle()) ? null : await routeHydration();
      const selectionId = new URLSearchParams(window.location.search).get('vehicle_selection_id')
        || hydration?.selectionId
        || '';
      const selection = manifest.selections[selectionId];
      const values = selection ? {
        make: selection.makeLabel,
        model: selection.modelLabel,
        year: customerYearLabel(selection),
      } : hydration?.makeLabel && hydration?.modelLabel && hydration?.yearLabel ? {
        make: hydration.makeLabel,
        model: hydration.modelLabel,
        year: hydration.yearLabel,
      } : null;
      if (!values) {
        root.hidden = true;
        if (legacySummary) {
          legacySummary.hidden = false;
          legacySummary.style.removeProperty('display');
        }
        return;
      }
      Object.entries(values).forEach(([key, value]) => {
        const node = root.querySelector(`[data-sbv-summary-${key}]`);
        if (node) node.textContent = value;
      });
      root.dataset.vehicleSelectionId = selection?.vehicle_selection_id || '';
      root.hidden = false;
      if (legacySummary) {
        legacySummary.hidden = true;
        legacySummary.style.setProperty('display', 'none');
      }
      root.dataset.sbvSummaryReady = 'true';
    } catch (error) {
      root.hidden = true;
      if (legacySummary) {
        legacySummary.hidden = false;
        legacySummary.style.removeProperty('display');
      }
      root.dataset.sbvSummaryError = 'manifest';
      console.warn(error);
    } finally {
      delete root.dataset.sbvSummaryLoading;
    }
  };

  const initWithin = (node = document) => {
    mountInlineSelectors(node);
    const start = root => {
      if (window.hooniesVehicleData && ['header', 'sidebar'].includes(root.dataset.sbvSurface) && root.getClientRects().length === 0) {
        if (root.dataset.sbvDeferred === 'true') return;
        root.dataset.sbvDeferred = 'true';
        const observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          observer.disconnect();
          delete root.dataset.sbvDeferred;
          init(root);
        });
        observer.observe(root);
        return;
      }
      init(root);
    };
    if (node.matches?.(SELECTOR)) start(node);
    node.querySelectorAll?.(SELECTOR).forEach(start);
    if (node.matches?.(SUMMARY)) initSummary(node);
    node.querySelectorAll?.(SUMMARY).forEach(initSummary);
  };

  const rehydrateFromLocation = () => document.querySelectorAll(`${SELECTOR}:not([data-sbv-suppressed-duplicate="true"])`).forEach((root) => {
    if (typeof root.hooniesApplyVehicleSelectionFromLocation === 'function') {
      root.hooniesApplyVehicleSelectionFromLocation();
      return;
    }
    init(root);
  });

  const rehydrateSummariesFromLocation = () => document.querySelectorAll(SUMMARY).forEach((root) => {
    delete root.dataset.sbvSummaryReady;
    initSummary(root);
  });

// Exact customer make/model labels and calendar years from the existing selector.
// This resolves navigation only; it never constructs fitment or merges models.
function createVehicleTextResolver(manifest) {
  const normalise = value => String(value || '').normalize('NFKC').toLowerCase()
    .replace(/[\u2010-\u2015]/g, '-').replace(/\s+/g, ' ').trim();
  const models = new Map();
  for (const make of manifest.makes) for (const model of make.models) {
    const key = normalise(make.makeLabel + ' ' + model.modelLabel);
    const identity = make.makeId + '|' + model.modelId;
    const previous = models.get(key);
    if (previous && previous.identity !== identity) models.set(key, {ambiguous:true});
    else if (!previous) models.set(key, {identity, make, model});
  }
  return query => {
    const text = normalise(query), candidates = [];
    const last = text.match(/^(.+) (\d{4})$/), first = text.match(/^(\d{4}) (.+)$/);
    if (last) candidates.push([last[1], last[2]]);
    if (first) candidates.push([first[2], first[1]]);
    const matches = candidates.map(([label, year]) => {
      const row = models.get(label);
      if (!row || row.ambiguous) return null;
      const cohort = row.model.cohorts.find(c => c.yearLabel === year && c.yearStart === Number(year) && c.yearEnd === Number(year));
      const selection = cohort && manifest.selections[cohort.vehicle_selection_id];
      return {status:selection ? 'matched' : 'unlisted-year', year,
        label:row.make.makeLabel + ' ' + row.model.modelLabel + ' ' + year,
        modelSelectionId:row.model.vehicle_selection_id,
        makeKey:row.make.makeKey,
        selectionId:selection?.vehicle_selection_id || null};
    }).filter(Boolean);
    return matches.length === 1 ? matches[0] : null;
  };
}

function initVehicleTextSearch() {
  let resolveQuery = null;
  const pageUrl = new URL(window.location.href);
  const isSearch = url => /\/search\/?$/.test(url.pathname);
  const supported = name => ['q','type','options[prefix]','page','sort_by','filter.p.vendor',
    'preview_theme_id','_fd','pb'].includes(name) || name.startsWith('utm_');
  const unsupported = params => [...params.keys()].some(name => !supported(name))
    || params.getAll('filter.p.vendor').length > 1
    || (params.has('type') && !['','product'].includes(params.get('type')));
  const destination = (match, params) => {
    const prefix = pageUrl.pathname.match(/^(.*)\/search\/?$/)?.[1]
      || String(window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    const url = new URL(prefix + '/collections/all-products', pageUrl.origin);
    url.searchParams.set('vehicle_selection_id', match.selectionId || match.modelSelectionId);
    for (const name of ['filter.p.vendor','sort_by','preview_theme_id','_fd','pb']) {
      if (params.has(name)) url.searchParams.set(name, params.get(name));
      else if (['preview_theme_id','_fd','pb'].includes(name) && pageUrl.searchParams.has(name))
        url.searchParams.set(name, pageUrl.searchParams.get(name));
    }
    return url.pathname + url.search;
  };
  const searchRoot = isSearch(pageUrl) ? document.querySelector('.template-search') : null;
  const incoming = pageUrl.searchParams.get('q') || '';
  let message = null, priorDisplay = null;
  const hideResults = text => {
    if (!searchRoot) return;
    if (!message) {
      message = document.createElement('section');
      message.className = 'wrap shop-section';
      message.dataset.vehicleTextSearchStatus = 'true';
      message.setAttribute('role', 'status');
      searchRoot.before(message);
      priorDisplay = searchRoot.style.display;
      searchRoot.style.display = 'none';
    }
    message.textContent = text;
  };
  const restoreResults = () => {
    if (message) { message.remove(); message = null; searchRoot.style.display = priorDisplay; }
  };
  // Prevent a direct link from briefly presenting keyword hits as vehicle results.
  if (searchRoot && /(^\s*\d{4}\s|\s\d{4}\s*$)/.test(incoming))
    hideResults('Finding parts for your vehicle…');
  const prepareQuery = async query => {
    const manifest = await load({ overview: true });
    const candidate = createVehicleTextResolver(manifest)(query);
    if (candidate?.makeKey && window.hooniesVehicleData) await load({ makeKey: candidate.makeKey });
    return manifest;
  };
  const looksLikeVehicle = query => /(^\s*\d{4}\s|\s\d{4}\s*$)/.test(query || '');
  (searchRoot && looksLikeVehicle(incoming) ? prepareQuery(incoming) : Promise.resolve(null)).then(manifest => {
    if (!manifest) return;
    resolveQuery = createVehicleTextResolver(manifest);
    window.hooniesVehicleSelectionManifest.resolveTextQuery = resolveQuery;
    if (!searchRoot) return;
    const match = resolveQuery(incoming);
    if (!match) { restoreResults(); return; }
    if (match.status === 'matched' && !unsupported(pageUrl.searchParams)) {
      hideResults('Finding parts for ' + match.label + '…');
      window.location.replace(destination(match, pageUrl.searchParams));
      return;
    }
    hideResults('');
    const heading = document.createElement('h1'), explanation = document.createElement('p'), link = document.createElement('a');
    heading.textContent = match.status === 'unlisted-year' ? 'No verified parts found for ' + match.label : 'View parts for ' + match.label;
    explanation.textContent = match.status === 'unlisted-year'
      ? 'We do not currently have verified parts listed for this year. Choose another year or contact us with your vehicle details.'
      : 'Open your vehicle results, then reapply your product filters there.';
    link.textContent = match.status === 'unlisted-year' ? 'Choose another year' : 'View vehicle results';
    // Unsupported native criteria are not silently carried into a different filter system.
    const clean = new URLSearchParams();
    for (const key of ['preview_theme_id','_fd','pb']) if (pageUrl.searchParams.has(key)) clean.set(key,pageUrl.searchParams.get(key));
    link.href = destination(match, clean);link.className = 'btn btn--amber';
    message.replaceChildren(heading, explanation, link);
  }).catch(() => {
    restoreResults();
    if (!searchRoot || !/(^\s*\d{4}\s|\s\d{4}\s*$)/.test(incoming)) return;
    const warning = document.createElement('p');warning.className = 'wrap';warning.setAttribute('role','status');
    warning.textContent = 'Vehicle matching is unavailable right now. These are keyword search results; please check each product’s fitment before ordering.';
    searchRoot.prepend(warning);
  });
  // A warmed header takes the direct route. Cold submissions use the same direct-URL handler.
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get') return;
    const action = new URL(form.action, pageUrl);
    if (action.origin !== pageUrl.origin || !isSearch(action)) return;
    const params = new URLSearchParams(new FormData(form));
    if (!looksLikeVehicle(params.get('q'))) return;
    event.preventDefault();event.stopImmediatePropagation();
    try {
      const manifest = await prepareQuery(params.get('q'));
      resolveQuery = createVehicleTextResolver(manifest);
      window.hooniesVehicleSelectionManifest.resolveTextQuery = resolveQuery;
      const match = resolveQuery(params.get('q'));
      if (match && match.status === 'matched' && !unsupported(params)) {
        window.location.assign(destination(match, params));
        return;
      }
    } catch (error) { console.warn(error); }
    action.search = params.toString();
    window.location.assign(action.pathname + action.search);
  }, true);
}

  window.hooniesVehicleSelectionManifest = { version: 'sbv-cohort-v1', load, decode: decodeRuntimeManifest, init, initSummary, initWithin, resolveCollection:canonicalCollectionVehicle };
  initVehicleTextSearch();
  window.addEventListener('hoonies:vehicle-selection-draft', (event) => {
    document.querySelectorAll(`${SELECTOR}:not([data-sbv-suppressed-duplicate="true"])`).forEach((root) => root.hooniesApplyVehicleDraft?.(event.detail));
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    rehydrateFromLocation();
    rehydrateSummariesFromLocation();
  });
  window.addEventListener('popstate', () => {
    rehydrateFromLocation();
    rehydrateSummariesFromLocation();
  });
  new MutationObserver((records) => {
    // Menus, options and app widgets add many unrelated elements. Only mount
    // newly inserted vehicle surfaces; their own option updates need no scan.
    const surfaces = `${SELECTOR},${SUMMARY},${VEHICLE_PANEL}`;
    const candidates = new Set();
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1 || !node.isConnected) return;
      if (node.matches(surfaces) || node.querySelector(surfaces)) candidates.add(node);
    }));
    const roots = [...candidates];
    roots.filter(node => !roots.some(other => other !== node && other.contains(node)))
      .forEach(node => initWithin(node));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
